module.exports = __webpack_public_path__ + "static/media/Carrosel_Inteligencia_Competitiva.fa1521e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Carrosel_Inteligencia_Competitiva.png
// module id = 276
// module chunks = 0